import routerOptions0 from "/opt/dasei/source/node_modules/.pnpm/nuxt@3.13.2_@parcel+watcher@2.5.0_@types+node@20.17.6_encoding@0.1.13_eslint@8.57.1_ioredis@5_oogdwkfncumbysopzqdpvczk4i/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}